import React from 'react'
import styles from './styles.module.less'
export default () => (
  <div className={styles.routeLoader}>
    <div className={styles.loader}>
      <span />
    </div>
  </div>
)
